<template>
  <div>
    <div class="new_myPlan_box" :style="`background:${planId==item.id?'rgb(240, 250, 255)':'white'};`">
      <div class="box_title">
        <span v-if="planId==item.id" class="editing">编辑中</span>
        <span class="planIdBox">草稿:{{item.id}}</span>
        <img alt="" class="avatar">
        <span class="userName">{{item.createName}}</span>
        <span class="planNumber">方案数<span class="number">{{item.budgetMains.length}}</span></span>
        <span class="planNumber" v-if="item.budgetMains[item.showIndex]">浏览<span class="number">{{item.budgetMains[item.showIndex].viewsNumber}}</span></span>
        <span v-if="item.incomePrice" style="color: #DB4E1A;margin-right: 0.1rem;">收入 {{item.incomePrice}}</span>
        <span v-if="item.expenditurePrice" style="color: #DB4E1A;">支出 {{item.expenditurePrice}}</span>
        <span class="del_button" v-if="showDelete&&!item.incomePrice&&!item.expenditurePrice" @click.stop="delPlan(item)">
          <i class="el-icon-delete"></i>
        </span>
      </div>
      <div class="left_img_box">
        <img v-if="item.budgetMains[item.showIndex]&&item.budgetMains[item.showIndex].imageUrl" 
          :src="item.budgetMains[item.showIndex].imageUrl" alt="" width="100%" height="100%">
        <img v-else :src="require('@/assets/jpg/text.jpg')" alt="" width="100%" height="100%">
        <div class="time_box" v-if="item.budgetMains[item.showIndex]&&item.budgetMains[item.showIndex].updateTime">
          {{dateFormatYMD(item.budgetMains[item.showIndex].updateTime,'-')}}
          {{dateFormatHM(item.budgetMains[item.showIndex].updateTime)}}
        </div>
        <div class="planIndex_box" v-if="item.budgetMains.length>1">
          <div class="box_left">
          <img src="@/assets/svg/antFill-heart.svg" alt="">
          </div>
          <div class="box_right">方案{{item.showIndex+1}}</div>
        </div>
        <div v-if="!isLook">
          <div class="xundan_box" v-if="showInquiryButton&&item.inquiries&&item.inquiries.length>0" @click="goXunList(item)">查看详情
            <div class="xundan_icon">询</div>
          </div>
          <!-- <div class="xundan_box2" v-if="item.budgetMains[item.showIndex].customerImages.length>0">定制师
            <img v-for="(val,ind) in item.budgetListResponses[item.showIndex].customerImages" :key="ind" :src="val.userImageUrl?val.userImageUrl:'/static/resource/images/svg/ze-user-circle-o.svg'" alt="" :style="`background:white;right:${-5+(-5)*index}px;`" class="avatar_img">
          </div> -->
          <div class="copy_button" style="right:0.5rem;" v-if="showCopy" @click="showPlan(item)">
            <el-tooltip class="item" effect="dark" content="将该团设置为全公司人可见" placement="top">
              <svg-icon :iconClass="item.isShow===0?'eye-close':'eye-open'" :systemColor="'#7D7D7D'"></svg-icon>
            </el-tooltip>
          </div>
          <div class="copy_button" style="right:0.27rem;" v-if="showCopy">
            <el-tooltip class="item" effect="dark" content="复制该团内容并新建一个新团" placement="top">
              <img src="@/assets/svg/semiDesign-semi-icons-copy_add.svg" @click="copyPlan(item)" alt="">
            </el-tooltip>
          </div>
          <div class="copy_button" style="right:0.27rem;" v-if="showCopy&&item.planLock==0">
            <el-tooltip class="item" effect="dark" content="锁定该团（锁入之后不可再对该团进行任何的操作）" placement="top">
              <i class="el-icon-lock" @click="lockPlan(item)"></i>
            </el-tooltip>
          </div>
          <div class="copy_button" style="right:0.05rem;" v-if="showCopy" @click="sharePlan(item)">
            <el-tooltip class="item" effect="dark" content="将该团分享给客户" placement="top">
              <img src="@/assets/svg/iconPark-share-one.svg" alt="">
            </el-tooltip>
          </div>
          <div class="copy_button" style="right:0.05rem;" v-if="!showCopy" @click="recoveryPlan(item)">
            <el-tooltip class="item" effect="dark" content="恢复该团到我的行程里面" placement="top">
              <svg-icon :iconClass="'recovery'"></svg-icon>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="right_info_box">
        <el-carousel :ref="'elCarousel'+index" class="lunbo_box" :autoplay="!item.autoplay"
            @change="(newIndex, oldIndex) => {changeLunBo(newIndex, oldIndex, item);}"
          arrow="never" indicator-position="outside" height="1.17rem" :interval="4000">
          <el-carousel-item v-for="(itemTwo,indexTwo) in item.budgetMains" :key="indexTwo" >
            <div @click.stop="replaceStroke(item,itemTwo)">
              <el-tooltip placement="top">
                <div slot="content" v-if="showDelete">{{itemTwo.planName}}{{itemTwo.planName1}}</div>
                <div slot="content" v-else>{{item.planName}}</div>
                <div class="right_planName">
                  <span v-if="showDelete">{{itemTwo.planName}}</span>
                  <span v-else>{{item.planName}}</span>
                  <span class="greenPlace">{{itemTwo.planName1}}</span>
                  <span class="title" style="font-weight: normal;" v-if="itemTwo.budgetName&&itemTwo.budgetName!=''">&nbsp;&nbsp;{{itemTwo.budgetName}}</span>
                </div>
              </el-tooltip>
              <div class="right_price_box">
                <div class="start_time_box">
                  <div class="time_top">{{dateFormatMD(itemTwo.departureDate,"/")}}</div>
                  <div class="time_bottom">
                    <div class="left">D1</div>
                    <div class="right">{{new Date(itemTwo.departureDate).getFullYear()}}</div>
                  </div>
                </div>
                <div class="price_items one">
                  <div class="number">{{itemTwo.useNumber}}</div>
                  <div class="title">人数</div>
                </div>
                <div class="price_items one">
                  <div class="number">{{itemTwo.spotSize}}</div>
                  <div class="title">景点</div>
                </div>
                <div class="price_items one">
                  <div class="number">{{itemTwo.stateSize}}</div>
                  <div class="title">项目</div>
                </div>
                <div class="grayLine"></div>
                <div class="price_items two" v-if="showDelete">
                  <div class="number"><span class="black_font">{{(itemTwo.budgetDetailResult.totalPrice/itemTwo.useNumber).toFixed(2)}}</span>￥</div>
                  <div class="title">成本/人</div>
                </div>
                <div class="price_items two">
                  <div class="number"><span class="black_font">
                    {{(itemTwo.budgetDetailResult.saleTotalPrice/itemTwo.useNumber).toFixed(2)}}</span>￥
                  </div>
                  <div class="title">报价/人</div>
                </div>
                <div class="price_items two" v-if="showDelete">
                  <div class="number"><span class="black_font">
                    {{((itemTwo.budgetDetailResult.saleTotalPrice-itemTwo.budgetDetailResult.totalPrice)/itemTwo.useNumber).toFixed(2)}}</span>￥
                  </div>
                  <div class="title">利润/人</div>
                </div>
                <div class="price_items two" v-else>
                  <el-button type="primary" size="mini">查看详情</el-button>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <ul class="changeLunBox" v-if="item.budgetMains.length>1">
      <li v-for="(itemTwo,indexTwo) in item.budgetMains" :key="indexTwo" @click="changeBudgetIndex(item,indexTwo,index)" :class="item.showIndex===indexTwo?'checkedLi':''"></li>
    </ul>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import Pay from '@/components/Api/pay.js'
export default {
  props:{
    planId:{
      type:Number,
      default:null,
    },
    item:{
      type:Object,
      default:()=>{return{}}
    },
    showDelete:{
      type:Boolean,
      default:true,
    },
    showCopy:{
      type:Boolean,
      default:true,
    },
    isLook:{
      type:Boolean,
      default:false,
    },
    index:{
      type:Number,
      default:0,
    },
    showInquiryButton:{
      type:Boolean,
      default:false,
    }
  },
  methods:{
    goXunList(item){
      this.$emit("goXunList",item)
    },
    showPlan(item){
      this.$confirm('您确定要将该方案给公司其他人可见吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').updatePlan({planId:item.id}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"成功"})
            this.$set(item,"isShow",1)
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    sharePlan(item){
      item.budgetMain = item.budgetMains[item.showIndex]
      this.$emit("replaceStroke",item,'share')
    },
    lockPlan(item){
      this.$confirm('您确定锁住该团吗，锁定之后的团不能再进行任何的操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //锁团
        new Pay('pay').planPlanLock(item.id).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"锁团成功"})
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    replaceStroke(item,itemTwo){
      item.budgetMain = itemTwo
      this.$emit("replaceStroke",item)
    },
    changeLunBo(newIndex, oldIndex, item){
      this.$set(item,'showIndex',newIndex)
    },
    changeBudgetIndex(item,indexTwo,index){
      this.$set(item,'showIndex',indexTwo)
      this.$set(item,'autoplay',true)
      this.$refs['elCarousel'+index].setActiveItem(indexTwo)
    },
    delPlan(item){
      this.$emit("delPlan",item)
    },
    copyPlan(item){
      console.log('sxxx',item)
      this.$emit("copyPlan",item)
    },
    recoveryPlan(item){
      this.$emit("recoveryPlan",item)
    }
  }
}
</script>

<style lang="scss" scoped>
.new_myPlan_box:hover{
  box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);
}
.new_myPlan_box{
  position: relative;
  margin-top: 0.2rem;
  display: flex;
  .box_title{
    position: absolute;
    top: -0.1rem;
    right: 0;
    height: 0.22rem;
    display: flex;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    box-shadow: 0px 2px 6px 0px rgba(0 ,0 ,0 , 0.08);
    justify-content: flex-end;
    font-size:0.12rem;
    background-color: white;
    padding-left: 0.1rem;
    z-index: 3;
    .editing{
      font-weight: bold;
      color:#DB4E1A;
      margin-right:0.15rem;
    }
    .planIdBox{
      font-weight: bold;
      color:#02A0C6;
      margin-right:0.15rem;
    }
    .avatar{
      width:0.2rem;
      height: 0.2rem;
      border-radius:50%;
      margin-right:0.05rem;
    }
    .userName{
      color:#212121;
      margin-right: 0.15rem;
    }
    .planNumber{
      color:#212121;
      margin-right: 0.15rem;
      .number{
        color: #757575 ;
        margin-left: 0.05rem;
      }
    }
    .del_button{
      padding:0 0.05rem;
      border-radius:0 10px 0 0;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.18);
      cursor:pointer;
      .el-icon-delete{
        font-size:0.17rem;
        color: #BCBCBC ;
      }
    }
  }
  .left_img_box{
    width:1.76rem;
    height:1.17rem;
    position: relative;
    font-size: 0.12rem;
    .xundan_box{
      position: absolute;
      bottom:35px;
      right:11px;
      font-size:12px;
      color:white;
      height:19px;
      line-height: 19px;
      padding:0px 10px;
      padding-right:15px;
      border-radius:4px;
      background: rgba(230, 74, 25, 0.80);
      .xundan_icon{
          height:19px;
          width: 19px;
          border:1px solid rgba(230, 74, 25, 0.80);
          background:white;
          font-size:12px;
          color:#101010;
          text-align: center;
          line-height:19px;
          position:absolute;
          top:0;
          right:-5px;
          border-radius:50%;
      }
    }
    .copy_button{
      position:absolute;
      top:0.05rem;
      width: 0.2rem;
      height:0.2rem;
      border-radius: 50%;
      background:white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor:pointer;
      img{
        margin: auto;
        width:0.15rem;
        height:0.15rem;
      }
    }    
    img{
      border-radius:5px 0 0 5px;
    }
    .time_box{
      background:rgba(0,0,0,0.4);
      color:white;
      font-weight:bold;
      border-radius:4px;
      padding:0.02rem 0.08rem;
      position: absolute;
      bottom:0.05rem;
      right:0.06rem;
    }
    .planIndex_box{
      position:absolute;
      top:0;
      left:0;
      display: flex;
      .box_left{
        width:0.3rem;
        height:0.24rem;
        background: #E64A19;
        border-radius:5px 0 0 0;
        display: flex;
        img{
          margin:auto;
          width:0.12rem;
          height:0.12rem;
        }
      }
      .box_right{
        width:0.62rem;
        height:0.24rem;
        color:#869AA6;
        border-radius:0px 0px 5px 0px;
        border:1px solid #E64A19;
        line-height: 0.22rem;
        background:white;
        text-align:center;
      }
    }
  }
  .right_info_box{
    margin-left:15px;
    .title{
      font-size:0.12rem;
      color:#7F7F7F;//rgba(230, 74, 25, 0.80)
      margin-top: 0.03rem;
    }
    .lunbo_box{
      width:5.8rem;
      /deep/ .el-carousel__indicators{
        display: none;
      }
    }
    .right_planName{
      margin-top:0.18rem;
      color:#212121;
      font-size:0.16rem;
      font-weight:bold;
      margin-right:0.1rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      .greenPlace{
        color: #26505A;
      }
    }
    .right_price_box{
      margin-top:5px;
      height:0.49rem;
      width:100%;
      border-radius:3px;
      display: flex;
      align-items: center;
      .start_time_box{
        width: 1.02rem;
        height: 0.52rem;
        background: #F9F8F8;
        border-radius:5px;
        padding:0 0.125rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        .time_top{
          font-size:0.15rem;
          color: #296776;
        }
        .time_bottom{
          width:100%;
          display: flex;
          margin-top:0.02rem;
          justify-content: space-between;
          font-size:0.12rem;
          .left{ 
            color:#000000;
          }
          .right{
            color: #296776;
            font-weight: normal;
          }
        }
      }
      .grayLine{
        border-right:1.5px dotted #bbb;
        margin:0 0.15rem;
        height: 0.4rem;
      }
      .one{
        width:0.9rem;
      }
      .two{
        width:1.3rem;
      }
      .price_items{
        display: flex;
        flex-direction: column;
        align-items: center;
        .number{
          font-weight: bold;
          color: #7F7F7F;
        }
        .black_font{
          color:#101010;
        }
      }
    }
  }
}
.changeLunBox{
  display: flex;
  align-items: center;
  margin-top:8px;
  justify-content: center;
  li{
    width:8px;
    height:8px;
    border-radius: 50%;
    cursor: pointer;
    background:#D6D6D6;
    margin-right: 4px;
  }
  .checkedLi{
    background: #8C8C8C;
  }
}
</style>